<template>
  <Content stretch>
    <slot>no go/no-go component specified</slot>
  </Content>
</template>

<script>
import { showModal, hideModal } from '@/store'
import { mapMutations, mapState } from 'vuex'
import { Content } from '@neurotrack/web-shared-components'
import { ntDate } from '@neurotrack/web-core'
import essExamProps from '@/mixins/essExamProps'

export default {
  name: 'exam_go_no_go',
  components: { Content },
  mixins: [essExamProps],
  data() {
    return {
      trialStartTime: 0
    }
  },
  computed: {
    ...mapState(['modalVisible'])
  },
  methods: {
    completeExam() {
      this.$store.dispatch(`exam/${this.exam}/complete`, undefined, {
        root: true
      })
    },
    trackEvent(perception) {
      this.$store.dispatch(`exam/${this.exam}/trackEvent`, perception, {
        root: true
      })
    },
    ...mapMutations([showModal, hideModal]),
    handleResponse(data) {
      if (this.isPractice) {
        this.handlePractice(data)
      } else {
        this.handleExam(data)
      }
    },

    handlePractice({ event: { response, type } }) {
      const isCorrect = response === type
      const correctText = isCorrect ? 'correct' : 'incorrect'

      let headerKey
      let bodyKey

      if (response === 'early') {
        headerKey = 'go_no_go_feedback_header_early'
        bodyKey = 'go_no_go_feedback_body_early_web'
      } else {
        headerKey = `go_no_go_feedback_header_${correctText}`
        bodyKey = `go_no_go_feedback_body_${type}_${correctText}_web`
      }

      this.showModal({
        component: 'Generic',
        props: {
          body: this.$i18n.t(bodyKey),
          label: this.$i18n.t('go_no_go_button_continue')
        },
        title: this.$i18n.t(headerKey)
      })
    },

    handleExam({ event }) {
      const { response } = event
      const data = []
      const timeout = !['go', 'early'].includes(response)

      if (!timeout) {
        data.push({
          type: 'selection',
          value: 'yes'
        })
      }

      const perception = {
        exam_trial_id: this.trial.exam_trial_id,
        trial_start_time: this.trialStartTime,
        trial_end_time: ntDate.now(),
        metadata: {
          trial_scoring_type: this.trial.trial_scoring_type
        },
        data,
        timeout
      }

      this.trackEvent(perception)

      if (response === 'early') {
        this.showModal({
          component: 'Generic',
          props: {
            body: this.$i18n.t('go_no_go_feedback_body_early_web'),
            label: this.$i18n.t('go_no_go_button_continue')
          },
          title: this.$i18n.t('go_no_go_feedback_header_early')
        })
      } else {
        this.$emit('next')
      }
    },

    handleModal({ code }) {
      if (this.modalVisible && code === 'Space') {
        this.hideModal()
      }
    }
  },
  mounted() {
    window.addEventListener('keyup', this.handleModal)
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.handleModal)
  },
  watch: {
    modalVisible(isShowing, wasShowing) {
      if (wasShowing && !isShowing) {
        this.$emit('next')
      }
    },
    trial: {
      immediate: true,
      handler() {
        this.trialStartTime = ntDate.now()
      }
    },
    isExamComplete(complete) {
      if (complete) {
        this.completeExam()
      }
    }
  }
}
</script>

<style scoped></style>
